import React from "react";
import CarDeliveryTemplate from "../../sections/car-delivery-template";
import CarBookingDeliveryCheckout from "../../sections/car-booking-delivery-checkout";

/**
 * There is no integrations made for this component
 * The disgn was changed and this is currently not used
 * You are probably looking for BookingCarDelivery
 */

const CarBookingPayment = ({ fields }) => {
  const { backgroundImage, trustSealsImage } = fields;
  const carDeliverOrderDetails = {
    heading: {
      html: "<span>Booking details</span>"
    },
    body: {
      html: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Urna, amet, purus suspendisse volutpat sed.</p>"
    },
    open: false,
    deliveryDetails: {
      items: [
        {
          label: "Delivery method:",
          value: "Custom delivery"
        },
        {
          label: "Day:",
          value: "2021-03-15"
        },
        {
          label: "Time:",
          value: "08:00 - 11:00"
        },
        {
          label: "Price:",
          value: "€50"
        }
      ]
    },
    location: {
      heading: { label: "Location:" },
      street: { label: "Streetname 8" },
      city: { label: "412 68 Gothenburg" }
    }
  };
  const trustSeals = trustSealsImage.value?.src
    ? [
        {
          url: trustSealsImage.value.src
        }
      ]
    : [];
  return (
    <CarDeliveryTemplate fields={fields}>
      <CarBookingDeliveryCheckout fields={fields} bookingDetails={carDeliverOrderDetails} trustSeals={trustSeals} />
    </CarDeliveryTemplate>
  );
};
export default CarBookingPayment;
